import { MenuController } from './controller'
import template from './index.html'

Directive.$inject = []
function Directive() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {},
    controller: MenuController,
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default Directive